// @flow
import React, { Component } from 'react';

type Props = {
  addDisabled: boolean,
  deleteDisabled: boolean,
  isSecondary: boolean,
  onClickAdd: Function,
  onClickDelete: Function,
  title: string,
};

export default class PageHeader extends Component<Props> {
  static defaultProps = {
    addDisabled: false,
    deleteDisabled: true,
    isSecondary: false,
    onClickAdd: () => {},
    onClickDelete: () => {},
    title: '',
  };

  render() {
    const {
      addDisabled,
      deleteDisabled,
      isSecondary,
      onClickAdd,
      onClickDelete,
      title,
    } = this.props;
    return (
      <header
        className={`page-header ${
          isSecondary ? 'page-header-secondary' : 'page-header-primary'
        }`}
        data-test-name="header-text"
      >
        {title}
        <p className="buttons">
          <a
            className={`button is-outlined ${isSecondary ? '' : 'is-white'}`}
            disabled={addDisabled}
            onClick={onClickAdd}
            data-test-name="add"
          >
            <span className="icon is-large">
              <i className="fa fa-lg fa-plus-circle" />
            </span>
          </a>
          <a
            className={`button is-outlined ${isSecondary ? '' : 'is-white'}`}
            disabled={deleteDisabled}
            onClick={!deleteDisabled ? onClickDelete : undefined}
            data-test-name="remove"
          >
            <span className="icon">
              <i className="fa fa-lg fa-minus-circle" />
            </span>
          </a>
        </p>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/Pages/PageHeader.js